<template>

    <CobaltDashboard :info="null" :company="null" :withFilterBar="false" contentClasses="single ps-0 pe-0">

        <div class="np-home container">
            <div class="row">
                <div class="col pb-2">
                    <div class="np-header2 vertical-align-center">
                        <svg class="icon"><use href="@/assets/images/icons/message.svg#icon"></use></svg> {{ $t("UI.messages.chats")}}
                    </div>                    
                </div>
            </div>
            <div class="row h-100">
                <div class="col-4 d-flex flex-column h-100">
                    <div class="np-group np-group-column">
                        <div class="np-group justify-content-between pb-3">
                            <div class="np-field-group np-with-icon-right flex-grow-1 me-2">
                                <input name="search-field" type="text" class="np-text-input np-outline" :placeholder="$t('search.search')"/>
                                <svg class="field-icon at-left"><use href="@/assets/images/icons/search.svg#icon"></use></svg>
                            </div>
                            <button class="np-btn np-outline me-2">
                                <svg><use href="@/assets/images/icons/filter.svg#icon"></use></svg>
                            </button>
                            <button class="np-btn np-outline">
                                <svg><use href="@/assets/images/icons/plus.svg#icon"></use></svg>
                            </button>                    
                        </div>          
                    </div>
                    <div class="np-panel np-flex-1">
                        <div class="np-panel-body h-100 p-4">
                            <div class="np-group np-group-column py-1">
                                <PerfectScrollbar>
                                    <ul class="np-list">
                                        <li class="np-messenger-group np-group align-items-start p-2 pe-3 active" role="button">
                                            
                                            <CobaltProfile 
                                                firstName="Иван" 
                                                lastName="Иванович" 
                                                size="np-avatar-large mt-1 me-3"
                                                :short="true"
                                            />
                                            <div class="np-group np-group-column flex-grow-1">
                                                <div class="np-group justify-content-between  align-items-center mb-2 w-100">
                                                    <div class="np-font-ml np-lh-l np-color-primary me-2">Вячеслав Длиннаяфамилия</div>
                                                    <div class="np-color-primary-300 ms-2">Вчера</div>
                                                </div>
                                                <div class="np-group align-items-start w-100">
                                                    <div class="np-font-m np-lh-ml np-color-primary-600 me-2 np-flex-1">
                                                        <svg class="message-status"><use href="@/assets/images/icons/message_sended.svg"></use></svg>
                                                        Это тестовое сообщение для проверки функционала мессенджера...
                                                    </div>
                                                    <div class="np-group align-items-center">
                                                        <span class="np-badge-s np-btn-info me-1">3</span>
                                                        <div class="np-btn p-0">
                                                            <svg><use href="@/assets/images/icons/pin.svg#icon"></use></svg>
                                                        </div>                                                        
                                                    </div>
                                                </div>                                                    
                                            </div>
                                            
                                        </li> 
                                        <li class="np-messenger-group np-group align-items-start p-2 pe-3" role="button">
                                            
                                            <CobaltProfile 
                                                firstName="Петр" 
                                                lastName="Петрович" 
                                                size="np-avatar-large mt-1 me-3"
                                                :short="true"
                                            />
                                            <div class="np-group np-group-column flex-grow-1">
                                                <div class="np-group justify-content-between  align-items-center mb-2 w-100">
                                                    <div class="np-font-ml np-lh-l np-color-primary me-2">КОнстантинсла Длиннаяфамилиясла</div>
                                                    <div class="np-color-primary-300 ms-2">01.01.2025</div>
                                                </div>
                                                <div class="np-group align-items-start w-100">
                                                    <div class="np-font-m np-lh-ml np-color-primary-600 me-2 np-flex-1">Поставил(-а) реакцию “👌” на Ваше сообщение...</div>
                                                    <div class="np-group align-items-center">
                                                        <div class="np-btn p-0">
                                                            <svg><use href="@/assets/images/icons/pin.svg#icon"></use></svg>
                                                        </div>                                                        
                                                    </div>
                                                </div>                                                    
                                            </div>
                                            
                                        </li>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
                                    </ul>  
                                </PerfectScrollbar>   
                            </div>
                        </div>
                    </div>                               
                </div> 
                <div class="col-8 d-flex flex-column h-100">
                    <div class="np-panel messenger-panel np-flex-1">
                        <div class="np-panel-header messenger-header">
                            <CobaltProfile 
                                firstName="Иван" 
                                lastName="Иванович" 
                                size="np-avatar-large mt-1 ms-2 me-3"
                                :short="true"
                            />
                            <div class="np-group np-group-column flex-grow-1">
                                <span class="np-font-ml pb-1">Артем Смирнов</span>
                                <span class="np-color-primary-300">Был(-а) сегодня в 9:28</span>
                            </div>
                            <div class="np-group justify-content-between">
                                <div class="np-field-group np-with-icon-right flex-grow-1 me-2">
                                    <input name="search-field" type="text" class="np-text-input np-dark" :placeholder="$t('search.search')"/>
                                    <svg class="field-icon at-left"><use href="@/assets/images/icons/search.svg#icon"></use></svg>
                                </div>
                                <button class="np-btn np-dark me-2">
                                    <svg><use href="@/assets/images/icons/filter.svg#icon"></use></svg>
                                </button>
                            </div>                             
                        </div>
                        <div class="np-panel-body messenger-body h-100">
                            <div class="row g-0 no-gutters h-100">
                                <div class="col-8 messages-wrapper">
                                    <div class="messages">
                                        <PerfectScrollbar>
                                            <div class="message">
                                                <div class="message__profile">
                                                    <CobaltProfile 
                                                        firstName="Иван" 
                                                        lastName="Иванович" 
                                                        size="np-avatar np-avatar-small mt-1 me-3"
                                                        :short="true"
                                                    />                                                
                                                </div>
                                                <div class="message__body">
                                                    <div class="message__content">
                                                        В целом, конечно, сплочённость команды целом, конечно, сплочённость команды профессионалов обеспечивает широкому кругу (специалистов).
                                                    </div>
                                                    <div class="message__footer">
                                                        <div class="left">
                                                            <div class="message-info" v-if="false"></div>
                                                            <div class="message-reactions">
                                                                👌😁 
                                                                <CobaltProfile 
                                                                    firstName="Иван" 
                                                                    lastName="Иванович" 
                                                                    size="np-avatar np-avatar-xs ms-1"
                                                                    marginRight="me-0"
                                                                    :short="true"
                                                                />                                                        
                                                            </div>
                                                        </div>
                                                        <div class="right">
                                                            <div class="message-time">17:25</div>
                                                            <div class="message-status ms-2">
                                                                <svg class="message-status"><use href="@/assets/images/icons/message_sended.svg"></use></svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="message my-message">
                                                <div class="message__profile">
                                                    <CobaltProfile 
                                                        firstName="Иван" 
                                                        lastName="Иванович" 
                                                        size="np-avatar np-avatar-small mt-1 me-3"
                                                        :short="true"
                                                    />                                                
                                                </div>
                                                <div class="message__body">
                                                    <div class="message__content">
                                                        Тестовое сообщение для проверки функционала
                                                    </div>
                                                    <div class="message__footer">
                                                        <div class="message-info" v-if="false"></div>
                                                        <div class="message-reactions">
                                                            😁 
                                                            <CobaltProfile 
                                                                firstName="Иван" 
                                                                lastName="Иванович" 
                                                                size="np-avatar np-avatar-xs ms-1"
                                                                marginRight="me-0"
                                                                :short="true"
                                                            />                                                         
                                                        </div>
                                                        <div class="message-time">17:25</div>
                                                        <div class="message-status ms-2">
                                                            <svg class="message-status"><use href="@/assets/images/icons/message_sended.svg"></use></svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="message">
                                                <div class="message__profile">
                                                    <CobaltProfile 
                                                        firstName="Иван" 
                                                        lastName="Иванович" 
                                                        size="np-avatar np-avatar-small mt-1 me-3"
                                                        :short="true"
                                                    />                                                
                                                </div>
                                                <div class="message__body">
                                                    <div class="message__content">
                                                        Хорошо, так и есть
                                                    </div>
                                                    <div class="message__footer">
                                                        <div class="message-info"></div>
                                                        <div class="message-time">17:25</div>
                                                        <div class="message-status ms-2">
                                                            <svg class="message-status"><use href="@/assets/images/icons/message_sended.svg"></use></svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>   
                                            <div class="message">
                                                <div class="message__profile">
                                                    <CobaltProfile 
                                                        firstName="Иван" 
                                                        lastName="Иванович" 
                                                        size="np-avatar np-avatar-small mt-1 me-3"
                                                        :short="true"
                                                    />                                                
                                                </div>
                                                <div class="message__body image">
                                                    <div class="message__content">
                                                        <img src="@/assets/images/test/tiger.png">
                                                    </div>
                                                    <div class="message__footer">
                                                        <div class="left">
                                                            <div class="message-info"></div>
                                                        </div>
                                                        <div class="right">
                                                            <div class="message-time">17:25</div>
                                                            <div class="message-status ms-2">
                                                                <svg class="message-status"><use href="@/assets/images/icons/message_sended.svg"></use></svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>            
                                            <div class="message">
                                                <div class="message__profile">
                                                    <CobaltProfile 
                                                        firstName="Иван" 
                                                        lastName="Иванович" 
                                                        size="np-avatar np-avatar-small mt-1 me-3"
                                                        :short="true"
                                                    />                                                
                                                </div>
                                                <div class="message__body">
                                                    <div class="message__content">
                                                        Хорошо, так и есть
                                                    </div>
                                                    <div class="message__footer">
                                                        <div class="left">
                                                            <div class="message-info">00:11 34.0Kb</div>
                                                        </div>
                                                        <div class="right">
                                                            <div class="message-time">17:25</div>
                                                            <div class="message-status ms-2">
                                                                <svg class="message-status"><use href="@/assets/images/icons/message_sended.svg"></use></svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="message">
                                                <div class="message__profile">
                                                    <CobaltProfile 
                                                        firstName="Иван" 
                                                        lastName="Иванович" 
                                                        size="np-avatar np-avatar-small mt-1 me-3"
                                                        :short="true"
                                                    />                                                
                                                </div>
                                                <div class="message__body">
                                                    <div class="message__content">
                                                        <div class="message__reply">
                                                            <div class="reply-author">Иванов Иван</div>
                                                            <div class="reply-content">В целом, конечно, сплочённость команды целом, конечно, сплочённость команды профессионалов обеспечивает широкому.</div>
                                                        </div>
                                                        Хорошо, так и есть
                                                    </div>
                                                    <div class="message__footer">
                                                        <div class="message-info"></div>
                                                        <div class="message-time">17:25</div>
                                                        <div class="message-status ms-2">
                                                            <svg class="message-status"><use href="@/assets/images/icons/message_sended.svg"></use></svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>                                                                                       
                                        </PerfectScrollbar>                                                                                    
                                    </div>  
                                    <div class="messenger-sender">
                                        <button class="np-btn np-gray">
                                            <svg><use href="@/assets/images/icons/squircle.svg#icon"></use></svg>
                                        </button>   
                                        <div class="np-field-group  flex-grow-1 me-2">
                                            <input name="search-field" type="text" class="np-text-input np-transparent np-border-none" :placeholder="$t('UI.messages.writeMessage')"/>
                                        </div>                                            
                                        <button class="np-btn np-gray me-2">
                                            <svg><use href="@/assets/images/icons/mic.svg#icon"></use></svg>
                                        </button>    
                                        <button class="np-btn np-btn-primary-light np-p-custom-0">
                                            <svg><use href="@/assets/images/icons/send2.svg#icon"></use></svg>
                                        </button>                                                                        
                                    </div>
                                </div>
                                <div class="col-4 p-4">
                                    <div class="messenger-archive">
                                        <div class="np-group np-group-column">
                                            <div class="messenger-archive__header">
                                                <svg class="icon"><use href="@/assets/images/icons/image.svg#icon"></use></svg>
                                                <div class="np-font-m me-2">Фотографии</div>
                                                <div class="np-badge-s np-gray">567</div>
                                            </div>
                                        </div>
                                        <div class="np-group messenger-archive__items-group mt-3">
                                            <div class="ma__image-item"><img src="@/assets/images/test/g1.png"></div>
                                            <div class="ma__image-item"><img src="@/assets/images/test/g2.png"></div>
                                            <div class="ma__image-item"><img src="@/assets/images/test/g3.png"></div>
                                            <div class="ma__image-item"><img src="@/assets/images/test/g4.png"></div>
                                            <div class="ma__image-item"><img src="@/assets/images/test/g5.png"></div>
                                            <div class="ma__image-item"><img src="@/assets/images/test/g6.png"></div>
                                            <div class="ma__image-item"><img src="@/assets/images/test/g7.png"></div>
                                            <div class="ma__image-item"><img src="@/assets/images/test/g8.png"></div>
                                            <div class="ma__image-item"><img src="@/assets/images/test/g9.png"></div>
                                            <div class="ma__image-item"><img src="@/assets/images/test/g10.png"></div>
                                        </div>
                                        <div class="messenger-archive__footer">
                                            <a href="#">Все фотографии</a>
                                        </div>
                                    </div>
                                    <div class="messenger-archive">
                                        <div class="np-group np-group-column">
                                            <div class="messenger-archive__header">
                                                <svg class="icon"><use href="@/assets/images/icons/folder2.svg#icon"></use></svg>
                                                <div class="np-font-m me-2">Файлы</div>
                                                <div class="np-badge-s np-gray">23</div>
                                            </div>
                                        </div>
                                        <div class="np-group messenger-archive__items-group mt-3">
                                            <div class="ma__file-item">
                                                <div class="ma__file-item-preview">
                                                    <img src="@/assets/images/test/g1.png">
                                                </div>
                                                <div class="np-group np-group-column np-flex-1">
                                                    <a href="#">g1.png</a>
                                                    <div class="np-group np-color-primary-300 np-flex-1 justify-content-between pt-2">
                                                        <div class="np-font-s">23Kb</div>
                                                        <div class="np-font-s">20.12.2025</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ma__file-item">
                                                <div class="ma__file-item-preview">
                                                    МА
                                                </div>
                                                <div class="np-group np-group-column np-flex-1">
                                                    <a href="#">assets_images_test_g1.png</a>
                                                    <div class="np-group np-color-primary-300 np-flex-1 justify-content-between pt-2">
                                                        <div class="np-font-s">23Kb</div>
                                                        <div class="np-font-s">20.12.2025</div>
                                                    </div>                                      
                                                </div>          
                                            </div>
                                        </div>
                                        <div class="messenger-archive__footer">
                                            <a href="#">Все файлы</a>
                                        </div>
                                    </div>                                    
                                </div>                                
                            </div>
                        </div>
                    </div>                     
                </div>
            </div>
        </div>

    </CobaltDashboard>

</template>

<script>

import CobaltDashboard from "@/components/dashboard/CobaltDashboard.vue"
import CobaltProfile from "@/components/dashboard/parts/CobaltProfile.vue"
import { mapGetters, mapActions } from 'vuex';
import Config from '../config.js'

export default {
    components: {
        CobaltDashboard,
        CobaltProfile
    },
    data() {
        return {
            Config,
            compInfo: null,
        }
    },
    beforeMount: function () {
        //this.getListComp()
    },
    computed: {
             
    },
    methods: {
        ...mapActions('company', ['list', 'addCompany', 'delete']),
        ...mapGetters('company', ['getList']),      
    }

}
</script>

<style>
/*** Messenger ***/
    .messenger-panel {
        border: none !important;
    }
    .np-messenger-group {
        border-radius: 0;
    }
    .np-messenger-group.active {
        border-radius: var(--base-value-2);
        background-color: var(--color-primary-50);
    }    
    .messenger-header {
        background-color: var(--color-primary-700);
        border: 1px solid var(--color-primary-700);
        border-top-left-radius: var(--base-value-2);
        border-top-right-radius: var(--base-value-2); 
        padding-left: var(--base-value-2); 
        color: var(--color-secondary-10);
        align-items: center;
    }
    .messenger-body {
        background-color: var(--color-primary-10);
        border: 1px solid var(--color-primary-200);
        border-bottom-left-radius: var(--base-value-2);
        border-bottom-right-radius: var(--base-value-2);
        border-top: 0;
        padding: 0 !important;
        max-height: 100%;
        flex: 1;
        overflow: hidden;        
    }
    .messages-wrapper {
        display: flex;
        flex-direction: column;
        border-right: 1px solid var(--color-primary-200);
        overflow: hidden;
        height: 100%;
    }
    .messages {
        flex-grow: 1;
        overflow: hidden;         
        padding: var(--base-value-4);
    }
    .message {
        display: flex;
        flex-direction: row;
        margin: var(--base-value-4) 0;
    }
    .messages .ps {
        height: 100%;
    }    
    .message__body {
        display: flex;
        flex-direction: column;
        border: 1px solid var(--color-primary-100);
        background-color: var(--color-secondary-10);
        padding: var(--base-value-4) var(--base-value-4) var(--base-value-2) var(--base-value-4);
        border-radius: var(--base-value-2);
        border-top-left-radius: 0;
        overflow: hidden;
    }
    .message__content {
        padding-bottom: var(--base-value-2);
    }
    .message__reply {
        color: var(--color-primary-600);
        background-color: var(--color-ocean-100);
        border-radius: var(--base-value-2);
        border-left: var(--base-value-1) solid var(--color-ocean-500);
        padding: var(--base-value-2) var(--base-value-4);
        margin-bottom: var(--base-value-2);
    }
    .message__footer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .message__footer .right, .message__footer .left {
        display: flex;
        align-items: center;
    }    
    .message-info {
        color: var(--color-primary-300);
        margin-inline-end: var(--base-value-2);
    }
    .message-reactions {
        display: flex;
        flex-direction: row;
        background-color: var(--color-primary-100);
        border-radius: var(--base-value-4);
        padding: 2px 4px;
        justify-content: center;
        align-items: center;
    }
    .message-time {
        flex: 1;
        text-align: right;
        color: var(--color-primary-300);
    }
    .message-status {
        display: inline;
        min-width: 16px;
        min-height: 20px;  
        width: 16px;
        height: 16px;
    }
    .reply-content {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .my-message .message__body {
        background-color: #425D8A;
        border-color: #425D8A;
        color: var(--color-secondary-10);
    }    
    .my-message .message-reactions {
        background-color: var(--color-ocean-400);
    }
    .my-message .message-time {
        font-size: 14px;
        color: var(--color-secondary-10); 
    }

    .messenger-sender {
        flex-shrink: 0;
        border-top: 1px solid var(--color-primary-200);
        border-bottom-left-radius: var(--base-value-2);
        background-color: var(--color-secondary-10);
        padding: var(--base-value-2);
        display: flex;
    }


    .message__body.image {
        position: relative;
        padding: 0;
        border-top-left-radius: var(--base-value-2);
    }
    .message__body.image .message__content {
        padding-bottom: 0;
    }    
    .message__body.image .message__content img {
        border-radius: var(--base-value-2);
    }    
    .message__body.image .message__footer {
        position: absolute;
        left: 0;
        right: 0;
        bottom: var(--base-value-2);
    }
    .message__body.image .message-time {
        flex:0;
        background-color: #5A5A5AA6;
        color: var(--color-secondary-10);
        border-radius: var(--base-value-2);
        padding: var(--base-value-1) var(--base-value-2);
    }   
    .messenger-archive {
        margin-bottom: var(--base-value-4);
    }
    .messenger-archive:not(:first-child) {
        padding-top: var(--base-value-3);
    }    
    .messenger-archive__header {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .messenger-archive__items-group {
        display: flex;
        gap: 5px 5px;
        flex-wrap: wrap;
    }    
    .ma__image-item {
        width: 60px;
        height: 60px;
        border-radius: 3px;
        overflow: hidden;
    }
    .ma__file-item {
        display: flex;
        flex-wrap: nowrap;
        width: 100%;
        align-items: center;
    }   
    .ma__file-item a {
        text-overflow: ellipsis;
    }
    .ma__file-item-preview {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        border-radius: 3px;
        overflow: hidden;    
        padding: 0;    
        margin-right: var(--base-value-2);
        background-color: var(--color-primary-100);
    }
    .messenger-archive__footer {
        margin-top: var(--base-value-2);
    }
</style>